import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
const bottomCutoutMixin = css `
  clip-path: polygon(0 0, 100% 0, 100% 100%, calc(50% + 6px) 100%, 50% calc(100% - 6px), calc(50% - 6px) 100%, 0 100%);
`;
export const arcaneSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}
  ${chroma.typography.display8}
  text-transform: none;
  padding: 21px 24px;

  &:not(.variant-tertiary) {
    ${bottomCutoutMixin}
    background-repeat: no-repeat;
    background-size: 61px 100%;
    background-position:
      0 0,
      100% 0;
  }

  &.variant-primary.disabled {
    background-blend-mode: luminosity;
  }

  &.variant-secondary {
    background-blend-mode: normal, luminosity;
  }

  &.variant-tertiary {
    ${chroma.typography.textLink};
    color: ${paletteTokens.bladetext1};

    .tertiary-icon {
      width: 12px;
      height: 12px;

      ${chroma.mediaQueries.mobileDown} {
        width: 10px;
        height: 10px;
      }
    }

    &:hover:not(.disabled) {
      color: ${paletteTokens.ctatext1_hover};

      .tertiary-icon {
        background-color: ${paletteTokens.ctatext1_hover};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map